export default "__VITE_ASSET__eb365311__"